import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavController, NavParams, LoadingController, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';

import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { MdaProvider } from 'src/app/services/mda/mda';


@Component({
  selector: 'app-mda-encontro-lista',
  templateUrl: './mda-encontro-lista.page.html',
  styleUrls: ['./mda-encontro-lista.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    SemRegistroComponent
  ],
})
export class MdaEncontroListaPage implements OnInit {
  loader = this.loadingController.create({
    message: this.translate.instant("Carregando")
  });
  id: string = '';
  encontros: any = [];
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public mdaProvider: MdaProvider,
    public modalCtrl: ModalController,
    private translate: TranslateService
  ) {

    this.id = navParams.get('idMda');
    // this.loader.present();
    this.mdaProvider.ultimosEncontros(this.id).subscribe((data) => {
      this.encontros = data;
      // this.loader.dismiss();
    });
  }

  ngOnInit() {
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
